/** Small form pieces shared by the survey editor (admin dark style). */

export const inputCls =
  "w-full px-3.5 py-2.5 rounded-xl bg-white/[0.04] border border-white/[0.06] text-[13px] text-white placeholder:text-zinc-600 focus:outline-none focus:border-emerald-500/30 transition-all disabled:opacity-50 [color-scheme:dark]";

export function Field({ label, hint, children }: { label: string; hint?: string; children: React.ReactNode }) {
  return (
    <label className="block">
      <span className="block text-[10px] font-semibold text-zinc-500 uppercase tracking-wider mb-1.5">{label}</span>
      {children}
      {hint && <span className="block text-[11px] text-zinc-600 mt-1">{hint}</span>}
    </label>
  );
}

export function Toggle({
  label,
  checked,
  disabled,
  onChange,
}: {
  label: string;
  checked: boolean;
  disabled?: boolean;
  onChange: (v: boolean) => void;
}) {
  return (
    <label className={`inline-flex items-center gap-2 text-[12.5px] ${disabled ? "opacity-50" : "cursor-pointer"} text-zinc-300`}>
      <input
        type="checkbox"
        className="accent-emerald-500"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      {label}
    </label>
  );
}

export function Card({ title, right, children }: { title?: string; right?: React.ReactNode; children: React.ReactNode }) {
  return (
    <div className="bg-white/[0.02] border border-white/[0.06] rounded-2xl p-5 space-y-4">
      {(title || right) && (
        <div className="flex items-center justify-between gap-3">
          {title && <span className="text-sm font-semibold text-white">{title}</span>}
          {right}
        </div>
      )}
      {children}
    </div>
  );
}

export const STATUS_STYLE: Record<string, string> = {
  draft: "bg-zinc-500/15 text-zinc-300",
  active: "bg-emerald-500/15 text-emerald-400",
  paused: "bg-amber-500/15 text-amber-400",
  ended: "bg-zinc-500/10 text-zinc-500",
};

export function StatusChip({ status }: { status: string }) {
  return (
    <span className={`px-2.5 py-0.5 rounded-full text-[10.5px] font-bold uppercase tracking-wide ${STATUS_STYLE[status] ?? STATUS_STYLE.draft}`}>
      {status}
    </span>
  );
}
